export default __webpack_public_path__ + "static/media/oasisFooter.2359d9ca.svg";